<template>
    <div class="container-warp">
        <img src="https://s20.lgstatic.com/growth/activity/20210928/1632809765330.png" alt="" class="privity-offter">
        <div class="section" v-for="(item, index) in PCimglist" :key="index" :id="'section_'+index">
            <img class="se-img" v-if="item.type == 'img'" :src="item.url">
            <button class="se-btn-1" v-else @click="JumpFn()" :style="{'background-image':'url('+item.url+')'}"></button>
            <div class="activityBox" v-if="activity.isShow && index == 0">
                <img class="activityImg" :src="activity.PCactiveImg">
            </div>
<!--            <div class="drawbtn-wrap">-->
<!--                <img  @click="JumpFn('领取免费学习资料')" src="https://s21.lgstatic.com/growth/activity/20211018/1634545850156.png" alt="" v-if="index===0" class="draw-btn draw-leftbtn">-->
<!--                <img  @click="JumpFn('领取1V1专业指导')" src="https://s21.lgstatic.com/growth/activity/20211018/1634546374639.png" alt="" v-if="index===0" class="draw-btn draw-rightbtn">-->
<!--            </div>-->
            <div  class="join-more"  v-if="index===1" @click="JumpFn('了解详情')"></div>
        </div>
        <div class="ceiling-view" v-if="ceilingType" :class="{'ceiling-fixed':ceilingType}">
            <div class="ceiling-tab">
                <div class="tab-item"
                    v-for="(item, index) in tabList" :key="index"
                    :class="{'active-tab': activeTab === index}"
                    @click="changeTab(item,index)"
                >
                    <span>{{item.stage}}</span>
                    <div v-if="activeTab === index" class="bor" />
                </div>
            </div>
        </div>
        <div class="section">
            <button class="se-btn-1" @click="JumpFn('测测我适合吗？')" :style="{'background-image':'url('+btnImgList[0]+')'}"></button>
        </div>
        <div class="section">
            <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20211018/1634523674619.png" alt="">
        </div>
        <div class="section">
            <button class="se-btn-1" @click="JumpFn('领取完整技能图谱')" :style="{'background-image':'url('+btnImgList[2]+')'}"></button>
        </div>
        <div class="sectione-main" id="section_main">
            <div class="section">
                <img class="auto-img auto-img1" src="https://s21.lgstatic.com/growth/activity/20211018/1634525577423.png" alt="">
            </div>
            <div class="main">
                <el-tabs v-model="activeName" @tab-click="changeTabs">
                    <el-tab-pane class="main-tab"
                        v-for="(item, index) in stageList" :key="index"
                        :label="item.stage" :name="index"
                    >
                        <div class="m">
                            <div class="m-title">
                                {{item.title}}
                            </div>
                            <img class="main-icon" src="https://s21.lgstatic.com/growth/activity/20210402/1617345169076.png">
                             <div class="main-t">
                                <div class="m-b">本章讲师</div>
                                <img @click="seeDetail(item)" class="detail" src="https://s20.lgstatic.com/growth/activity/20211011/1633932880073.png">
                            </div>
                            <div class="item">{{item.teacher}}</div>
                            <div class="main-t">
                                <div class="m-b">
                                    学习目标
                                </div>
                            </div>
                            <div class="item" v-for="(v, i) in item.phaseTargetList" :key="i" > {{v}}</div>
                            <div class="main-t">
                                <div class="m-b">
                                    核心章节
                                </div>
                            </div>
                            <div class="item" v-for="(v, i) in item.skillsList" :key="i" > {{v}}</div>
                            <div class="main-t">
                                <div class="m-b">实战应用</div>
                            </div>
                            <div class="item">{{item.applycation}}</div>
                        </div>
                    </el-tab-pane>
                </el-tabs>
                <div class="modal" v-if="showModal">
                    <img @click="close" class="close" src="https://s21.lgstatic.com/growth/activity/20210412/1618215171460.png">
                    <div v-for="(item, index) in showData.details" :key="index">
                        <div class="modal-title">
                            {{item.t}}
                        </div>
                        <div class="modal-desc" v-for="(i, is) in item.desc" :key="is">
                            {{i}}
                        </div>
                    </div>
                </div>
                <div class="tips-tab">
                        * 具体课程内容以实际课程安排和进度为准
                    </div>
                <button class="jump-btn" @click="JumpFn">
                    <img src="https://s20.lgstatic.com/growth/activity/20211018/1634526855730.png">
                </button>
            </div>
        </div>
        <div class="section">
            <img class="se-img" src="https://s21.lgstatic.com/growth/activity/20211018/1634529303573.png" alt="">
        </div>
        <template>
           <button
            class="footer" @click="JumpFn('名额有限立即抢占')" :style="{'background-image':'url('+PCfooterImg+')', 'height': '88px', 'background-size': '100%'}">
              <div class="iconBox" v-if="activity.isShow">
                  <img class="icon" :src="activity.PCicon">
              </div>
            </button>
          </template>
    </div>
</template>

<script>
import { handleJumpUrl } from '../../../uitl/getParam.js';
import Swiper from 'swiper';
import 'swiper/dist/css/swiper.css';
import activity from '../../../common/activity';
import List from './data.js'
import mixin from '../../../common/js/mixins/repurchase'

    export default {
        mixins: [mixin],
        data() {
            return {
                activity,
                List:List,
                SI: 0,
                touchImglist:[
                    {
                        url:"https://s20.lgstatic.com/growth/activity/20211015/1634280282347.png",
                        activeUrl:"https://s20.lgstatic.com/growth/activity/20211015/1634282850600.png",
                        top:"-121PX",
                        left:"-336PX"
                    },
                    {
                        url:"https://s20.lgstatic.com/growth/activity/20211015/1634281486359.png",
                        activeUrl:"https://s21.lgstatic.com/growth/activity/20211015/1634282871448.png",
                        top:"-121PX",
                        left:"231PX"
                    },
                    {
                        url:"https://s21.lgstatic.com/growth/activity/20211015/1634281505961.png",
                        activeUrl:"https://s21.lgstatic.com/growth/activity/20211015/1634282890496.png",
                        top:"42PX",
                        left:"-336PX"
                    },
                    {
                        url:"https://s20.lgstatic.com/growth/activity/20211015/1634281494855.png",
                        activeUrl:"https://s20.lgstatic.com/growth/activity/20211015/1634284737588.png",
                        top:"42PX",
                        left:"231PX"
                    },
                ],
                PCimglist: [
                    {url:"https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/all_operate/pc/%E5%85%A8%E6%A0%88%E8%BF%90%E8%90%A5%E5%AE%9E%E6%93%8D%E8%AE%AD%E7%BB%83%E8%90%A5%E5%A4%87%E4%BB%BD%402x.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20220120/1642665962387.jpg",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20211014/1634197782642.png",type:"btn",button_name:"评估我的薪资水平"},
                    {url:"https://s20.lgstatic.com/growth/activity/20211014/1634201894620.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20211014/1634197782642.png",type:"btn",button_name:"评估我的薪资水平"},
                    {url:"https://s21.lgstatic.com/growth/activity/20211014/1634202058649.png",type:"img"},
                    {url:"https://s20.lgstatic.com/growth/activity/20211014/1634202089030.png",type:"btn",button_name:"测测我适合吗？"},

                ],
                PCSwiperList1:[
                    "https://s20.lgstatic.com/growth/activity/20211018/1634544973543.png",
                    "https://s20.lgstatic.com/growth/activity/20211018/1634544985718.png",
                    "https://s21.lgstatic.com/growth/activity/20211018/1634544995472.png"
                ],
                btnImgList:[
                    "https://s21.lgstatic.com/growth/activity/20211018/1634523583379.png",
                    "https://s20.lgstatic.com/growth/activity/20211018/1634524094091.png",
                    "https://s20.lgstatic.com/growth/activity/20211018/1634524824762.png",
                    "https://s20.lgstatic.com/growth/activity/20211018/1634525371285.png",
                    "https://s21.lgstatic.com/growth/activity/20211018/1634549953501.png"
                ],
                PCimglist1: [
                    // "https://s20.lgstatic.com/growth/activity/20210928/1632803620771.png",
                    "https://s21.lgstatic.com/growth/activity/20210928/1632803680973.png",
                    "https://s21.lgstatic.com/growth/activity/20210928/1632803843730.png",
                    "https://s20.lgstatic.com/growth/activity/20210928/1632804374805.png",
                    "https://s21.lgstatic.com/growth/activity/20210928/1632808836534.png"
                ],
                PCfooterImg:"https://lagou-zhaopin-fe.lagou.com/jiaoyu/growth/all_operate/pc/%E5%90%B8%E5%BA%95%402x.png",
                stageList:[],
                courseId: 38,
                currTouchIndex:0,
                tabList:[],
                ceilingType:false,
                activeTab:0,
                showModal:false
            }
        },
        computed: {
            currentStage() {
                return this.stageList[this.SI] || {};
            },
        },
        created () {
            setTimeout(()=>{
                this.platTrack('pcpv', {
                    page_id: 'v1uay',
                })
            },500)

            let dataList = this.List.data
            this.stageList = dataList.stageList
        },
        mounted () {
            let dataList = this.List.data;
            const {tabList} = dataList;
            this.tabList = tabList;;
            window.addEventListener('scroll', this.scrollTopFn)
            this.renderSwiper()
        },
        destroyed () {
            window.removeEventListener('scroll', this.scrollTopFn)
        },
        methods: {
            changeTab(item,index) {
                this.activeTab = index
                let arr = [
                    "#section_0",
                    "#section_touch",
                    "#section_main",
                    "#section_end",
                ]
                this.$el.querySelector(arr[index]).scrollIntoView(true);
                let scroll = document.documentElement.scrollTop || document.body.scrollTop;
                document.documentElement.scrollTop = scroll - 100
                document.body.scrollTop = scroll - 100
                this.eduPlatTrack('WebButtonClick', {
                    'page_id': 'z1t6z',
                    'button_name': item.stage
                });
            },
            scrollTopFn() {
                let scroll = document.documentElement.scrollTop || document.body.scrollTop;
                this.ceilingType = scroll > 550 ? true : false; //吸顶tab
                let arr = [
                    "section_0",
                    "section_touch",
                    "section_main",
                    "section_end",
                ]
                arr.forEach((item,index) =>{
                    if(document.getElementById(item).getBoundingClientRect().top < 200) {
                        this.activeTab = index
                    }
                })
            },
            changeLearnProblem(index){
                this.currTouchIndex = index;
            },
            mouseOver(index){
                this.currTouchIndex = index;
            },
            mouseLeave(){
                // this.currTouchIndex = 0;
            },
            JumpFn(name) {
              if(name==='名额有限立即抢占'){
                this.platTrack('pcclick', {
                    page_id: 'v1uay',
                    address_id: 'x1ub1'
                })
              }

                setTimeout(() => {
                     handleJumpUrl(`b81a5c0d7dc94c3f88de261065ea56b3`);
                }, 500);
            },
            renderSwiper() {
                setTimeout(() => {
                    let modify = 0;
                    let translate = 0;
                    let scale = 0;
                    const swiper = new Swiper('.wrap', {
                        autoplay: 3000,
                        loop: true,
                        slidesPerView: 'auto',
                        loopedSlides: 4,
                        pagination: '.sw-pagination',
                        paginationClickable: true,
                        watchSlidesProgress: true,
                        // prevButton: '.swiper-button-prev',
                        // nextButton: '.swiper-button-next',
                        centeredSlides: true,
                        onSetTransition: (swiper, transition) => {
                            for (let i = 0; i < swiper.slides.length; i++) {
                                let slide = swiper.slides.eq(i);
                                slide.transition(transition);
                            }
                        },
                    });

                    swiper.on('progress', () => {
                        for (let i = 0; i < swiper.slides.length; i++) {
                            let slide = swiper.slides.eq(i);
                            let slideProgress = swiper.slides[i].progress;
                            modify = 1;
                            if (Math.abs(slideProgress) > 1) {
                                modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
                            }
                            translate = slideProgress * modify * 300 + 'PX';
                            scale = 1 - Math.abs(slideProgress) / 5;
                            let zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
                            slide.transform('translateX(' + translate + ') scale(' + scale + ')');
                            slide.css('zIndex', zIndex);
                        }
                    });
                }, 50);
            },
            seeDetail(val) {
                this.showModal = true;
                this.showData = val
            },
            close() {
                this.showModal = false;
            },
            changeTabs(val) {
                this.showModal = false
            },
        },
    }
</script>

<style lang="less" scoped>
.container-warp {
    width: 100%;
    padding-bottom: 156PX;
    background: #F4F4F4;
    position: relative;
    .privity-offter{
        position: absolute;
        top: 0;
        right: 15%;
        object-fit: contain;
        width: 104PX;
        height: 133PX;
    }
    button{
        cursor: pointer;
    }
    .ceiling-view {
        width: 100%;
        height: 66PX;
        margin: 0PX auto 40PX;
        background-color: #fff;
        .ceiling-tab {
            width: 1100PX;
            margin: 0 auto;
            height: 66PX;
            background-color: #fff;
            border-radius: 2PX;
            box-shadow: 0PX 6PX 8PX 0PX rgba(214, 209, 250, 0.08);
            display: flex;
            align-items: center;
            cursor: pointer;
            // transform: scale(.7);
            .tab-item {
                position: relative;
                flex: 1;
                text-align: center;
                font-size: 20PX;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #32355C;
                height: 100%;
                line-height: 66PX;
                box-sizing: border-box;
                .bor {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translate(-50%);
                    width: 168PX;
                    height: 3PX;
                    border-radius: 1PX;
                    background: linear-gradient(309deg, #FF5A37 0%, #991010 100%);
                }
            }
            .active-tab {
                box-sizing: border-box;
                padding-left: 40PX;
                &::before{
                    content: '';
                    width: 24PX;
                    height: 24PX;
                    background: url('https://s21.lgstatic.com/growth/activity/20211018/1634544795441.png') no-repeat center;
                    background-size: 100% 100%;
                    position: absolute;
                    left: 62PX;
                    top:50%;
                    transform: translateY(-50%);
                    transition-duration: 0.3s;
                }
            }

        }
        @media screen and (max-width:1900px){
            .ceiling-tab {
                width: 940PX;
                .tab-item {
                    .bor {
                        width: 148PX;
                    }
                }
                .active-tab {
                    padding-left: 40PX;
                    &::before{
                        left: 44PX;
                    }
                }
            }
        }
        @media screen and (max-width:1500px){
            .ceiling-tab {
                width: 790PX;
                .tab-item {
                    .bor {
                        width: 140PX;
                    }
                }
                .active-tab {
                    padding-left: 30PX;
                    &::before{
                        left: 26PX;
                    }
                }
            }
        }

    }
    .ceiling-fixed {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        z-index: 30;
    }
    .drawbtn-wrap {
        position: absolute;
        bottom: 70PX;
        left: 50%;
        display: flex;
        transform: translate(-50%);
        justify-content: space-between;
    }
    .draw-btn{
        width: 45%;
        height: auto;
        cursor: pointer;
    }
    .draw-rightbtn{
        right: 0;
        bottom: 0;
    }
    .join-more{
        position: absolute;
        width: 300PX;
        height: 88PX;
        left: 33%;
        bottom: 45PX;
    }
}
.section {
    width: 100%;
    font-size: 0;
    position: relative;
    margin: 0 auto;
    text-align: center;
    .se-img {
        width: 100%;
        display: block;
    }
    .auto-img{
        width: auto;
        margin: 20PX auto 150PX auto;
    }
    .auto-img1{
        margin: 20PX auto 50PX auto;
    }
    .activityBox {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%);
        width: 950PX;
        height: 150PX;
    }
    .activityImg {
        display: block;
        float: right;
        width: 104PX;
        height: 133PX;
    }
}
.se-btn-1 {
    width: 100%;
    height: 88PX;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    border: none;
    display: block;
    position: absolute;
    bottom: 10PX;
    background-color: #F4F4F4;
    cursor:pointer;
}
.concat{
    position: absolute;
    bottom: 15%;
}
.swiper-top{
    padding-top: 30PX;
    box-sizing: content-box;
}
.section-touch {
    width: 100%;
    min-width: 1232PX;
    overflow: hidden;
    position: relative;
    background-color: #F4F4F4;
    background-size: 100% 100%;
    .center {
        width: 462PX;
        margin: 0PX auto 60PX;
        position: relative;
        .touch-img {
            width: 462PX;
            height: 464PX;
            margin: 0 auto 6PX;
            background-position: center;
            background-repeat: no-repeat;
            background-size: 100% 100%;
        }
        .touch-item{
            width: 231PX;
            height: 231PX;
            float: left;
            position: relative;
        }
        .active-url{
            width: 336PX;
            height: 163PX;
            position: absolute;
        }
    }
}

.section-main {
    width: 100%;
    min-width: 1200PX;
    height: 639PX;
    margin-top: -1PX;
    background-color: #F4F4F4;
    background-size: auto 100%;
    overflow: hidden;
}
 .sectione-main {
        width: 100%;
        min-width: 1100PX;
        margin-bottom: 100PX;
        position: relative;

        .main {
            position: relative;
            width: 1100PX;
            margin: 0 auto;
            border-radius: 16PX;
            background-color: #fff;
            // padding-bottom: 100PX;
            .tips-tab {
                font-size: 14PX;
                color: #666;
                position: absolute;
                bottom: 80PX;
                right: 60PX;
            }
            .m {
                width: 100%;
                box-sizing: border-box;
                padding: 0 65PX 40PX;
            }
            .m-title {
                padding-top: 30PX;
                font-size: 28PX;
                font-family: SourceHanSansSC-Medium, SourceHanSansSC;
                font-weight: 400;
                color: #6469A7;
                text-align: center;
            }
            .main-icon {
                width: 688PX;
                height: 2PX;
                display: block;
                margin: 8PX auto 0;
            }
            .main-t {
                width: 100%;
                height: 50PX;
                padding-top: 35PX;
                margin-bottom: 20PX;
                .m-b {
                    float: left;
                    width: 166PX;
                    height: 46PX;
                    font-size: 24PX;
                    text-align: center;
                    line-height: 46PX;
                    border-radius: 50PX;
                    color: #6469A7;
                    background: linear-gradient(192deg, rgba(99, 137, 255, .1) 0%, rgba(108, 101, 255, .1) 100%);
                }
                .detail {
                    display: block;
                    width: 132PX;
                    height: 48PX;
                    float: right;
                }
            }
            .item {
                position: relative;
                font-size: 20PX;
                font-family: SourceHanSansSC-Light, SourceHanSansSC;
                color: #6469A7;
                margin: 10PX 20PX;
                padding-left: 15PX;
                &::after {
                    position: absolute;
                    content: '';
                    left: 0PX;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 6PX;
                    height: 6PX;
                    border-radius: 50%;
                    background: #6469A7;
                }
            }
            .modal {
                position: absolute;
                top: 190PX;
                left: 50%;
                transform: translate(-50%);
                width: 1100PX;
                border-radius: 16PX;
                background-color: #fefefe;
                z-index: 999;
                border: 2PX solid #6469A7;
                box-sizing: border-box;
                padding: 20PX 50PX 40PX;
                .close {
                    position: absolute;
                    right: 14PX;
                    top: 14PX;
                    width: 40PX;
                    height: 40PX;
                }
                .modal-title {
                    font-size: 20PX;
                    padding:35PX 0 10PX;
                    color: #6469A7;
                }
                .modal-desc {
                    font-size: 18PX;
                    color: #6469A7;
                    padding-left: 18PX;
                }
            }
            .jump-btn {
                position: absolute;
                left: 50%;
                transform: translate(-50%);
                bottom: -24PX;
                width: 408PX;
                height: 68PX;
                background-color:transparent;
                border: none;
                img {
                    width: 100%;
                    display: block;
                }
            }
        }
        /deep/ .el-tabs {
            width: 1100PX;
            margin: 30PX auto 0PX;
            .el-tabs__header, .el-tabs__nav-wrap, .el-tabs__nav-scroll {
                height: 96PX;
                border-top-left-radius: 16PX;
                border-top-right-radius: 16PX;
                background: linear-gradient(90deg, #0F60C6 0%, #0A015F 100%);
            }
            .el-tabs__item {
                line-height: 96PX;
                text-align: center;
                width: 140PX;
                height: 96PX;
                padding: 0;
                font-size: 22PX;
                font-family: SourceHanSansSC-Regular, SourceHanSansSC;
                color: #fff;
                font-weight: normal;
                &:hover {
                    color: #eee;
                }
            }
            .el-tabs__nav-prev {
                top: 50%;
                color: #fff;
                font-weight: 500;
                font-size: 34PX;
                transform: translateY(-50%);
            }
            .el-tabs__nav-wrap.is-scrollable {
                padding: 0 35PX;
            }
            .el-tabs__nav-next {
                top: 50%;
                color: #fff;
                font-weight: 500;
                font-size: 34PX;
                transform: translateY(-50%);
            }
            .el-tabs__nav-wrap::after{
                background-color: transparent;
            }
            .el-tabs__active-bar {
                background-color: transparent;
            }
            .el-tabs__item.is-active {
                color: #fff;
                font-weight: bold;
                font-size: 25PX;
            }
        }
    }
.mg-s {
    margin-top: -5PX;
}
.sw-section {
    width: 100%;
    padding: 30PX 0 30PX;
    /deep/ .wrap {
        width: 900PX;
        height: 360PX;
        .swiper-slide {
            width: 663PX;
            opacity: 0;
            img {
                display: block;
                width: 540PX;
                height: 280PX;
                margin: 0 auto;
                object-fit: contain;
            }
            &.swiper-slide-active {
                opacity: 1;
            }
            &.swiper-slide-next, &.swiper-slide-prev {
                opacity: .5;
            }
        }
        .swiper-pagination-bullet{
            width: 10PX;
            height: 10PX;
            background:  #D6D6D6;
            border-radius: 50%;
            opacity: .5;
            &-active{
                opacity: 1;
                border-radius: 10PX;
                width: 22PX;
                background: linear-gradient(250deg, #FF5325 0%, #EB0505 100%);
            }
        }
    }
    }
.footer {
    position: fixed;
    bottom: 0;
    z-index: 999;
    width: 100%;
    cursor: pointer;
    // height: 117PX;
    background-position: center;
    background-repeat: no-repeat;
    background-size: auto;
    border: none;
    font-size: 0;
    .iconBox {
        position: absolute;
        top: -30PX;
        left: 50%;
        transform: translate(-50%);
        z-index: 9999;
        width: 1060PX;
        .icon {
            float: right;
            width: 134PX;
        }
    }
    img {
      width: 100%;
    }
    .text-loop {
      position: absolute;
      width: 215PX;
      height: 37PX;
      right: 31.5%;
      top: 50%;
      transform: translateY(-50%);
      border: none;
      border-image-width: 0;
    }
}
.course-section {
    width: 1200PX;
    background: #FFFFFF;
    border-radius: 10PX;
    height: 500PX;
    margin: 0 auto;
    box-sizing: border-box;
}
.section-left {
    width: 140PX;
    background: #F07234;
    border-radius: 10PX;
    padding-top: 24PX;
    box-sizing: border-box;
}
.s-l-i {
    width: 122PX;
    height: 38PX;
    border-radius: 19PX;
    color: white;
    background: #F07234;
    border: none;
    margin: 8PX 0;
}
.s-l-i-a {
    background: #FFFFFF;
    color: #F07234;
}
.section-right {
    padding: 17PX 40PX;
    position: relative;
    .tips-tab {
        position: absolute;
        font-size: 14PX;
        color: #666;
        bottom: 10PX;
        right: 60PX;
    }
}
.n-top {
    padding: 8PX 0 12PX;
    border-bottom: 1PX solid #B7B7B7;
    font-size: 22PX;
    .n-t-d {
        color: #333333;
        font-weight: 600;
        padding-right: 48PX;
        min-width: 210PX;
    }
    .detail-course{
        font-weight: 600;
        color: #F07234;
        font-size: 22PX;
        cursor: pointer;
    }
}
.s-container {
    font-size: 18PX;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
}
.s-c-title {
    font-size: 20PX;
    font-weight: 500;
    color: #333333;
    position: relative;
    padding-left: 14PX;
    padding-bottom: 10PX;
    margin-top: 20PX;
    &:first-of-type {
        margin-top: 13PX;
    }
    &::before {
        position: absolute;
        content: '';
        width: 4PX;
        height: 20PX;
        margin-top: 4PX;
        left: 0;
        background: #F07234;
    }
}
.s-n-item {
    padding-left: 20PX;
    position: relative;
    &::before {
        width: 2PX;
        height: 2PX;
        border-radius: 50%;
        background: #666666;
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 5PX;
    }
}
.s-n-items {
    padding-left: 20PX;
    position: relative;
}
.its-2 {
    width: 100%;
    display: flex;
}
.sw-n-l {
    padding-left: 20PX;
    flex: 1;
}
.sw-n-r {
    flex: 1;
}
</style>
